import { RoomId, roomId, RoomMixerId, roomMixerId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomMixerStartedEventDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomMixerStartedEventDTO.validationSchema()
  );

  readonly data: RoomMixerStartedEvent;

  constructor(data: RoomMixerStartedEvent) {
    this.data = JsonSchemaValidator.assert(
      RoomMixerStartedEventDTO.validation,
      data
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "mixerId"],
      properties: {
        roomId,
        mixerId: roomMixerId
      },
      additionalProperties: false
    };
  }
}

export interface RoomMixerStartedEventJson extends RoomMixerStartedEvent {}

interface RoomMixerStartedEvent {
  roomId: RoomId;
  mixerId: RoomMixerId;
}
